import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Room } from '@rx-applications/clientsite/shared/utils';
import { TRANSLATION_SCOPE } from '../clientsite-checkout-room/i18n/translation.provider';
import { TranslocoDirective } from '@ngneat/transloco';

@Component({
  selector: 'rx-applications-clientsite-checkout-room-header',
  standalone: true,
  imports: [CommonModule, TranslocoDirective],
  templateUrl: './clientsite-checkout-room-header.component.html',
  styleUrls: ['./clientsite-checkout-room-header.component.scss'],
})
export class ClientsiteCheckoutRoomHeaderComponent {
  @Input() room: Room;
  @Input() index: number;
  protected readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;
}
